import authReducer from './authedReducer';
import { combineReducers } from 'redux';

export default combineReducers({
  authReducer,
});
